$(document)
  .ready(($) => {
    if ($('.js-slider-splide').length) {
      const splide = new Splide('.js-slider-splide', {
        type: 'loop',
        perMove: 1,
        gap: 40,
        padding: '30%',
        flickPower: 200,
        breakpoints: {
          640: {
            padding: '15%',
          },
        },
      });

      splide.on('pagination:mounted', function (data) {
        // You can add your class to the UL element
        data.list.classList.add('c-slider-splide__pagination');

        // `items` contains all dot items
        data.items.forEach(function (item) {
          item.button.classList.add('c-slider-splide__page');
        });
      });

      splide.mount();
    }

    if ($('.js-slider-splide-gallery').length) {
      const splideGallery = new Splide('.js-slider-splide-gallery', {
        type: 'fade',
        pagination: false,
      });

      splideGallery.mount();
    }
  });
